function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { InlineInput } from 'seagull/components/TableList/InlineControl/InlineInput';
import { useStore } from "../../store/store-context";
import { selectors } from "../../store/state-selectors";
import { IconButton, Tooltip } from 'seagull';
import { QboIcon } from "../../integrations/QBO/QboIcon";
import styles from "./ServiceLibrary.module.scss";
const QboServiceMappingIndication = props => {
  const {
    qboServiceDisplay
  } = props;
  const tooltipTitle = qboServiceDisplay ? "Synced with: ".concat(qboServiceDisplay) : 'Service is not mapped to QuickBooks Online';
  const intent = qboServiceDisplay ? 'success' : 'pending';
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "qbo-service-map-indication"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: /*#__PURE__*/React.createElement("div", {
      "data-testid": "qbo-service-map-tooltip"
    }, tooltipTitle)
  }, /*#__PURE__*/React.createElement(IconButton, {
    cursorDefault: true,
    skin: "transparent"
  }, /*#__PURE__*/React.createElement(QboIcon, {
    intent: intent
  }))));
};
export function ServiceRowName(_ref) {
  let {
    service,
    serviceNameValidation,
    qboServiceDisplay,
    onInlineEdit,
    onInputFocus,
    onInputBlur
  } = _ref;
  const showQboIntegration = useStore(selectors.integration.showQboIntegration);
  const {
    control,
    setValue
  } = useForm({
    mode: 'all',
    defaultValues: {
      name: service.name
    }
  });
  useEffect(() => {
    setValue('name', service.name);
  }, [service.name, setValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.serviceName
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "name",
    rules: serviceNameValidation,
    render: _ref2 => {
      var _fieldState$error;
      let {
        field,
        fieldState
      } = _ref2;
      return /*#__PURE__*/React.createElement(InlineInput, _extends({}, field, {
        onFocus: onInputFocus,
        onBlur: onInputBlur,
        onSave: name => onInlineEdit({
          name
        }),
        error: !!fieldState.error,
        errorText: (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message,
        errorTextInTooltip: true,
        testid: "service-library-row-name"
      }));
    }
  }), showQboIntegration && /*#__PURE__*/React.createElement(QboServiceMappingIndication, {
    qboServiceDisplay: qboServiceDisplay
  }));
}